var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrimboxLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 192C149.019 192 192 149.019 192 96C192 42.9807 149.019 0 96 0C42.9807 0 0 42.9807 0 96C0 149.019 42.9807 192 96 192Z",
    fill: "#43FFDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.9 116.262L118.086 32.1579L118.024 32.1461C110.012 30.604 102.266 35.8496 100.724 43.862L87.3309 113.458L85.0146 125.504L99.4015 127.389L101.9 116.262Z",
    fill: "#E5E1E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3558 108.139L104.046 105.119L109.563 76.4511L93.8728 79.4704L88.3558 108.139Z",
    fill: "#D7D0D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.139 73.3965L159.095 73.167L74.9908 89.3524L67.232 91.5571L69.3624 104.594L77.7948 103.922L147.558 90.496C155.478 88.9718 160.663 81.3162 159.139 73.3965Z",
    fill: "#EFEDEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.084 127.22C112.579 136.101 112.144 149.394 103.777 157.761C94.9478 166.59 80.6364 166.59 71.8093 157.763C62.9804 148.934 62.9804 134.622 71.8093 125.793C74.4005 123.202 77.4655 121.373 80.7231 120.302L81.5423 116.05C81.9224 114.077 83.8298 112.784 85.8031 113.164L103.431 116.557C105.405 116.937 106.696 118.843 106.318 120.818L105.084 127.22ZM96.8344 150.819C101.828 145.825 101.828 137.731 96.8344 132.737C91.8394 127.743 83.7447 127.743 78.7515 132.736C73.7566 137.731 73.7566 145.825 78.7515 150.82C83.7448 155.814 91.8394 155.814 96.8344 150.819Z",
    fill: "#4059FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4362 94.4195C35.4413 99.4144 35.4413 107.509 40.4345 112.502C45.4295 117.497 53.5241 117.497 58.5191 112.502C63.5123 107.509 63.5123 99.4144 58.5174 94.4195C53.5241 89.4263 45.4295 89.4262 40.4362 94.4195ZM78.0911 105.451C78.4712 107.424 77.1782 109.331 75.2048 109.712L70.9527 110.531C69.8819 113.788 68.0526 116.853 65.4614 119.445C56.6325 128.273 42.3211 128.273 33.4922 119.445C24.6652 110.618 24.6652 96.306 33.494 87.4772C41.8611 79.11 55.1538 78.6744 64.0347 86.1703L70.4372 84.9363C72.4123 84.558 74.318 85.8493 74.698 87.8226L78.0911 105.451Z",
    fill: "#4059FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.951 94.126C96.2319 93.407 96.2321 92.2415 96.951 91.5227L97.7745 90.6991C98.4934 89.9803 99.6588 89.9801 100.378 90.6991C101.097 91.4182 101.097 92.5836 100.378 93.3025L99.5543 94.126C98.8354 94.8449 97.67 94.8451 96.951 94.126Z",
    fill: "#E5E1E5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrimboxLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trimbox-logo.53bd204c8e6188ccae5df837e5e3295e.svg";